<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.menu.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headleft">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.menu.add')}}</el-button>
                    <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">{{$t('pages.menu.delete')}}</el-button>
                </div>
                <div class="handle-headright">
                    <el-input v-model="query.Field2" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.menu.namePh')"></el-input>
                    <el-input v-model="query.Field1" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.menu.codePh')"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.menu.search')}}</el-button>
                </div>
            </div>
            <el-table
                :data="menus"
                border
                class="table"
                ref="multipleTable"
                :element-loading-text="$t('pages.menu.loading')"
                v-loading="loading"
                row-key="id"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
                @row-dblclick="dbSelected"
                :default-expand-all="false"
                :expand-row-keys="expandRowKeys"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                highlight-current-row
                style="width: 100%"
                @select-all="onSelectAll"
                @select="onSelect"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50" :label="$t('pages.menu.index')"></el-table-column>
                <el-table-column prop="title" :label="$t('pages.menu.title')"></el-table-column>
                <el-table-column sortable prop="code" :label="$t('pages.menu.code')"></el-table-column>
                <el-table-column :label="$t('pages.menu.enabled')">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enabledFt" @change="changeUse(scope.row)" />
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="enabled" label="是否使用">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.enabled === '1' ? 'primary' : 'danger'" disable-transitions>{{
                            scope.row.enabled | usertypeFormat
                        }}</el-tag>
                    </template>
                </el-table-column>-->
                <el-table-column prop="sort" :label="$t('pages.menu.sort')"></el-table-column>
                <el-table-column :label="$t('pages.menu.actions.edit')" width="110" align="center">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" icon="el-icon-tickets" @click="handleShow(scope.row.id, scope.row)">查看 </el-button> -->
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.id, scope.row)">{{$t('pages.menu.actions.edit')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog :title="headTitle" :visible.sync="editVisible" width="50%" :close-on-click-modal="false" @close="clsOpt">
            <el-form ref="menu" :model="menu" :rules="rules" label-width="90px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.menu.fields.parent')" prop="parentId">
                            <el-cascader v-model="menu.parentId" :options="menuarr" key="menu.parentId" :props="{ checkStrictly: true }" class="size-full" clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.menu.fields.title')" prop="title">
                            <el-input v-model="menu.title"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.menu.fields.code')" prop="code">
                            <el-input v-model="menu.code" :disabled="!isadd"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.menu.fields.icon')" prop="icon">
                            <icon-picker v-model="menu.icon"></icon-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.menu.fields.sort')" prop="sort">
                            <el-input oninput="value=value.replace(/[^0-9.]/g,'')" v-model="menu.sort" class="size-full"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.menu.fields.enabled')" prop="enabledFt">
                            <el-switch v-model="menu.enabledFt"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('pages.menu.fields.remark')" prop="remark">
                            <el-input type="textarea" v-model="menu.remark" class="size-full"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">{{$t('pages.menu.dialog.cancel')}}</el-button>
                <el-button type="primary" @click="saveEdit('menu')">{{$t('pages.menu.dialog.confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { dateFormat, SortField, toTree } from '../../utils/helper';
import { formatTime, treeToList, listToTree, getTreeParents } from '../../utils';
let that;
export default {
    name: 'menuA',
    data: function () {
        const checkPass = (rule, value, callback) => {
            if (value !== this.menu.Password) {
                callback(new Error('两次输入密码不一致！'));
            } else {
                callback();
            }
        };

        return {
            headTitle: '',
            isadd: false,
            menu: {},
            editVisible: false,
            menus: [],
            multipleSelection: [],
            expandRowKeys: [],
            delList: [],
            loading: false,
            menuarr: [],
            query: {
                Field1: '',
                Field2: ''
            },
            rules: {
                code: [
                    {
                        required: true,
                        message: this.$t('pages.menu.rules.codeRequired'),
                        trigger: 'blur'
                    },
                    {
                        min: 2,
                        max: 25,
                        message: this.$t('pages.menu.rules.lengthRange'),
                        trigger: 'blur'
                    }
                ],
                title: [
                    {
                        required: true,
                        message: this.$t('pages.menu.rules.titleRequired'),
                        trigger: 'blur'
                    }
                ],
                sort: [
                    {
                        required: true,
                        message: this.$t('pages.menu.rules.sortRequired'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    filters: {
        formateData(time) {
            let date = new Date(time);
            return dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm');
        },
        areaFieldList(menu) {
            return menu.province + '-' + menu.city + '-' + menu.area;
        },
        cloudSpace(menu) {
            return menu.useSpace + '/' + menu.cloudSpace;
        },
        usertypeFormat(UserType) {
            var usertypeName = '';
            if (UserType == '1') {
                usertypeName = '启用';
            } else {
                usertypeName = '停用';
            }
            return usertypeName;
        }
    },
    created() {
        this.getData();
    },
    beforeCreate() {
        that = this;
    },
    methods: {
        saveEdit() {
            this.$refs['menu'].validate((valid) => {
                if (valid) {
                    this.menu.enabled = this.menu.enabledFt ? '1' : '0';
                    var parentidPath = this.menu.parentId;
                    this.menu.parentId = parentidPath[parentidPath.length - 1];
                    this.menu.parentIdPath = parentidPath.join(',');
                    this.menu.sort = this.menu.sort == NaN ? 0 : parseInt(this.menu.sort);
                    console.log(this.menu);
                    //return;
                    if (this.isadd) {
                        this.$zybhttp
                            .post('Menu/MenuAdd', this.menu)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.menu.notify.addSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                    this.menu = {};
                                } else {
                                    this.$notify.error(this.$t('pages.menu.notify.addFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.menu.notify.networkAddError')));
                    } else {
                        this.$zybhttp
                            .post('Menu/MenuUpdate', this.menu)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.menu.notify.updateSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error(this.$t('pages.menu.notify.updateFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.menu.notify.networkUpdateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getData() {
            // this.loading=true;
            this.$zybhttp
                .post('menu/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('sort', 'asc'));
                        newdata = newdata.map((x) => {
                            x.enabledFt = x.enabled == '1';
                            return x;
                        }, []);
                        const keys = newdata.filter((l) => l.parentId === 9999).map((l) => l.id + '');
                        this.expandRowKeys = keys;
                        // var idd = this.MenuCarding(newdata);
                        var idd = listToTree(newdata);
                        this.menus = idd;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.menu.notify.networkListError')));
        },
        changeUse(row) {
            row.enabled = row.enabledFt ? '1' : '0';
            //this.$notify.error(JSON.stringify(row));
            this.$zybhttp
                .post('Menu/MenuUpdate', row)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('pages.menu.notify.updateSuccess'));
                        this.getData();
                    } else {
                        this.$notify.error(this.$t('pages.menu.notify.updateFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.menu.notify.networkUpdateError')));
        },
        getmenuArr: function () {
            this.$zybhttp
                .post('menu/GetMenuList', { Field1: '9999' })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        d = d.sort(SortField('id', 'asc'));
                        var arr = [{ id: 0, pid: 9999, value: 0, label: this.$t('pages.menu.root') }];
                        for (var i = 0; i < d.length; i++) {
                            arr.push({ id: d[i].id, pid: d[i].parentId, value: d[i].id, label: d[i].title });
                        }
                        this.menuarr = toTree(arr);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.menu.notify.networkListError')));
        },
        handleEdit(id, row) {
            this.getmenuArr();
            this.menu = JSON.parse(JSON.stringify(row));
            this.menu.id = id;
            this.editVisible = true;
            this.menu.enabledFt = this.menu.enabled == '1';
            this.isadd = false;
            var arr = new Array();

            var d = this.menu.parentIdPath.split(',');
            for (var i = 0; i < d.length; i++) {
                arr.push(parseInt(d[i]));
            }
            this.menu.parentId = arr;
            this.headTitle = this.$t('pages.menu.dialog.editTitleUpdate');
        },
        dbSelected(row) {
            this.getmenuArr();
            this.menu = JSON.parse(JSON.stringify(row));
            this.menu.id = row.id;
            this.editVisible = true;
            this.menu.enabledFt = this.menu.enabled == '1';
            this.isadd = false;
            var arr = new Array();
            var d = this.menu.parentIdPath.split(',');
            for (var i = 0; i < d.length; i++) {
                arr.push(parseInt(d[i]));
            }
            this.menu.parentId = arr;
            this.headTitle = this.$t('pages.menu.dialog.editTitleUpdate');
            // console.log(row);
        },
        handleAdd() {
            this.getmenuArr();
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.menu = {};
            this.isadd = true;
            let date = new Date();
            // this.menu.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.menu.createUserId = userinfo.loginId;
            this.menu.modifyUserId = userinfo.loginId;
            //this.menu.isUse =true;
            this.editVisible = true;
            this.headTitle = this.$t('pages.menu.dialog.editTitleAdd');
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].title + ' ';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.menu.notify.deleteSelectedWarning'));
                return;
            }
            this.$confirm(this.$t('pages.menu.notify.deleteConfirm'), this.$t('pages.menu.notify.deleteConfirmTitle'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('menu/menuDel?ids=1')
                        .get('menu/MenuDel', {
                            params: { ids: strValue }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('pages.menu.notify.deleteSuccess', { names: str }));
                                this.getData();
                            } else {
                                this.$notify.error(this.$t('pages.menu.notify.deleteFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.menu.notify.networkDeleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        indexMethod(index) {
            return index + 1;
        },
        onSelectAll: function (selection) {
            const selections = treeToList(selection);
            const rows = treeToList(this.viewTree);
            const checked = selections.length === rows.length;
            rows.forEach((row) => {
                this.$refs.multipleTable.toggleRowSelection(row, checked);
            });

            this.sels = this.$refs.multipleTable.selection;
        },
        onSelect: function (selection, row) {
            const checked = selection.some((s) => s.id === row.id);
            if (row.children && row.children.length > 0) {
                const rows = treeToList(row.children);
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row, checked);
                });
            }

            this.sels = this.$refs.multipleTable.selection;
        },
        MenuCarding(data) {
            var menus = [];
            var d = JSON.parse(JSON.stringify(data));
            var dOne = d.filter((x) => x.parentId == 9999);
            // var dOne = d.filter(function (e) {
            //     return e.parentId == 9999;
            // });
            var dOneSort = dOne.sort(SortField('sort', 'asc'));
            menus = menus.concat(dOneSort);
            menus.forEach((x) => {
                var pid = x.id;
                var dtwo = d.filter((x) => x.parentId == pid);
                if (dtwo.length > 0) {
                    var dtwoSort = dtwo.sort(SortField('sort', 'asc'));
                    x.children = dtwoSort;
                }
            });
            return menus;
        },
        clsOpt() {
            this.menu.enabled = this.menu.enabled ? '1' : '0';
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>

<style>
/* 富文本框高度设置 */
.ql-container {
    min-height: 200px;
    height: 200px;
}
</style>
